import styled from 'styled-components';
import { textLinkPrimary, titleMedium } from 'styles-js/mixins/typography';
import UserLink from 'src/modules/shared/links/userLink';

export const Subtitle = styled.h3`
  ${titleMedium};
  padding-bottom: 5px;
  margin-bottom: 10px;
  border-bottom: ${({ theme }) => theme.greyLine};
`;

export const SupportingMembers = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SupportingMemberEl = styled.div`
  padding-bottom: 15px;
  width: 50%;
  min-width: 200px;
`;

export const SupportingMemberAvatar = styled.div`
  float: left;
  margin-right: 10px;
  padding-top: 5px;
`;

export const SupportingMemberUser = styled.div`
  float: left;
  width: calc(100% - 60px);
`;

export const SupportingMemberLink = styled(UserLink)`
  ${textLinkPrimary};
  overflow-wrap: break-word;
  word-wrap: break-word;
  padding-left: 4px;
  display: block;
`;

export const InputWrapper = styled.div<{ isInvalid?: boolean }>`
  position: relative;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid ${({ isInvalid, theme }) => isInvalid ? theme.colorError : theme.colorGreyLight};
  border-radius: 4px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colorGreyDark};
`;

export const Input = styled.input<{ isFocused?: boolean; withCounter?: boolean }>`
  display: block;
  width: ${({ withCounter }) => withCounter ? 'calc(100% - 70px)' : '100%'};
  height: ${({ isFocused, theme }) => isFocused ? 'auto' : theme.fontLineHeightS};
  line-height: ${({ theme }) => theme.fontLineHeightS};
  padding: 0;
  border: none;
`;

export const Textarea = styled.textarea<{ isFocused?: boolean }>`
  display: block;
  width: ${({ isFocused }) => isFocused ? '100%' : 'calc(100% - 70px)'};
  height: ${({ isFocused, theme }) => isFocused ? '108px' : theme.fontLineHeightS};
  line-height: ${({ theme }) => theme.fontLineHeightS};
  padding: 0;
  border: none;
  @media (${props => props.theme.underScreenSmall}) {
    resize: none;
  }
`;

export const Counter = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  min-width: 66px;
  text-align: right;
  color: ${({ theme }) => theme.colorGreyDark};
`;

export const StyledError = styled.p`
  margin: 5px 0 10px;
  color: ${({ theme }) => theme.colorError};
`;
